import React from "react";
import PropTypes from "prop-types";

import styles from "./DashboardByline.css";
import classNames from "classnames";
import withTooltip from "components/library/Tooltip/withTooltip";

const Text = ({ text }) => <span>{text}</span>;
const TextWithTooltip = withTooltip(Text);

class DashboardByline extends React.Component {
  constructor(props) {
    super(props);
  }

  /**
   * @param {Object} name -- with first and last name
   * @todo Change this to be a displayName property of some sort?
   */
  formatName(name) {
    return `${name.first_name} ${name.last_name}`;
  }

  formatEditor(name) {
    return `Ed: ${this.formatName(name)}`;
  }

  /**
   * @returns { byline, numAuthors, tooltip} -- text to appear on main dashboard, total author count, text to appear in tooltip
   */
  formatAuthors(props) {
    let byline;
    let tooltip = [];
    let leftovers = [];
    const authors = props.authors
      ? props.authors.map(i => this.formatName(i))
      : [];
    const editors = props.editors
      ? props.editors.map(i => this.formatEditor(i))
      : [];
    const hasAuthors = authors.length > 0;
    const people = [...authors, ...editors];

    if (people.length) {
      byline = `${people[0]}${
        people.length > 1 ? ` + ${people.length - 1}` : ""
      }`;
      leftovers = people.slice(1);
    }

    if (leftovers.length) {
      tooltip = leftovers.map((name, i) => {
        return <div key={`name${i}`}>{name}</div>;
      });
    }

    return { byline, hasAuthors, tooltip };
  }

  render() {
    const formattedAuthors = this.formatAuthors(this.props);
    let text;
    if (formattedAuthors.tooltip.length) {
      text = (
        <TextWithTooltip
          tooltip={formattedAuthors.tooltip}
          isTooltipLeftAligned={true}
          text={formattedAuthors.byline}
        />
      );
    } else {
      text = formattedAuthors.byline;
    }

    return (
      <div
        className={classNames(
          styles.root,
          formattedAuthors.hasAuthors ? styles.author : styles.editor
        )}
      >
        {text}
      </div>
    );
  }
}

DashboardByline.propTypes = {
  authors: PropTypes.array,
  editors: PropTypes.array,
  setTooltipText: PropTypes.func,
};

export default withTooltip(DashboardByline);
